import { Button, Modal } from "antd";

type Props = {
    visible: boolean,
    onClose: () => void,
}

const WelcomeModal: React.FC<Props> = ({ visible, onClose }) => {
    return (
        <Modal
            visible={visible}
            footer={null}
            closable={true}
            centered
            closeIcon
        >
            <div style={{ padding: "10px 5px" }}>
                <p style={{ fontWeight: 500 }}>
                    Avant d'explorer la plateforme, il te faut :
                </p>

                <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
                    <li style={{ marginBottom: "8px", fontSize: "14px" }}>
                        modifier ton mot de passe temporaire
                    </li>
                    <li>
                        renseigner des informations complémentaires essentielles sur ton profil comme ton numéro de téléphone WhatsApp afin que l'on puisse te tenir informé de tes cours et des messages reçus !
                    </li>
                </ul>

                <div style={{ marginTop: "20px", display: "flex", gap: "10px", flexDirection: "column" }}>
                    <Button type="link" onClick={onClose} className="classBtn classBtn-teal">
                        Fermer
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default WelcomeModal;